import React from 'react'
import type { ReactElement } from 'react'
import clock from './assets/clock.svg'
import 'react-datepicker/dist/react-datepicker.css'
import { CourierService } from './types/models'
import CourierServiceOption from './CourierServiceOption'

type ChooseDeliverySlotProps = {
  courierServices: CourierService[];
  selectedCourierService: CourierService | null;
  setSelectedCourierService: (service: CourierService) => void;
}

const ChooseDeliverySlot = (
  { courierServices, selectedCourierService, setSelectedCourierService }: ChooseDeliverySlotProps
): ReactElement => {
  return (
    <>
      <div className="choose-delivery-slot-header">
        <h2 className="heading-with-image">
          <img
            alt=""
            className="icon clock-icon"
            aria-hidden="true"
            loading="lazy"
            src={clock} width="15" height="16"
          />
            Choose Delivery Time Slot
        </h2>

        <div className="delivery-slot-selection">
          {courierServices.map((service: CourierService, index: number):
          ReactElement => (
            <CourierServiceOption
              courierService={service}
              isSelected={selectedCourierService?.id === service.id}
              setSelectedCourierService={setSelectedCourierService}
              key={index}
            />
          ))}
        </div>
        <p className='delivery-slot-note'>Our all-day service runs 8am-6pm, or you can upgrade to choose a slot that suits you.</p>
      </div>
    </>
  )
}

export default ChooseDeliverySlot
